import React from 'react'
import { getLiveApi } from './api'


import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'
import { Rules, RulesResponse } from '../common/types/api/RuleResponse'

export default async function getAlarms(): Promise<Rules[]> {
    try {
        const alarmResponse = await getLiveApi<RulesResponse>(`rule`)

        return alarmResponse.data
    } catch (error) {
        const errorMsg = i18n('Error trying to get Rule: ')
        GlobalNotification.error(<Notification title={errorMsg}>{error}</Notification>, 20)
        console.error(errorMsg, error)

        return []
    }
}

export async function getAlarmById(id: number): Promise<RulesResponse> {
    try {
        const alarmResponse = await getLiveApi<RulesResponse>(`rule/${id}`)

        return alarmResponse
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to get Report: ')}>
                <tr>
                    <strong>Alarm id: </strong> {id}
                </tr>
                {error}
            </Notification>,
            20
        )

        console.error(error)

        return {
            data: []
        }
    }
}

export function mockGetLookups(data: Rules[]): () => Promise<Rules[]> {
    return function (): Promise<Rules[]> {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(data)
            }, 1000)
        })
    }
}
